<div class="h-100 overflow-auto crm-scroll">
  <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3 bg-white position-sticky top-0 z-5">
    <h4 class="m-0 text-crm">
      {{ isUpdate ? ('dialogs.update_site' | translate) : ('dialogs.add_site' | translate) }}
    </h4>
    @if (baseService.isMobile) {
      <app-button (onChangeClick)="onNoClick()" [btnType]="'icon'" matTooltip="{{ 'close' | translate }}">
        <app-icon>close</app-icon>
      </app-button>
    }
  </div>

  <mat-divider class="my-2"></mat-divider>

  @if (isLoader) {
    <div class="d-flex justify-content-center">
      <app-loader size="small"></app-loader>
    </div>
  } @else {
    @if (siteForm) {
      <div class="d-flex flex-column gap-3 px-4 py-2" [formGroup]="siteForm">
        <app-text-field
          label="{{ 'name' | translate }}"
          [formControl]="siteForm.controls.name"
          [error]="siteForm.controls.name.invalid && siteForm.controls.name.touched"
        ></app-text-field>
        @if (siteForm.controls.name.touched && siteForm.controls.name.invalid) {
          <mat-hint class="text-danger"> {{ 'name_site_cannot_be_empty' | translate }}. </mat-hint>
        }
        <app-text-field
          label="{{ 'subdomain' | translate }}"
          [formControl]="siteForm.controls.subdomain"
          [error]="siteForm.controls.subdomain.invalid && siteForm.controls.subdomain.touched"
        ></app-text-field>
        @if (siteForm.controls.subdomain.touched && siteForm.controls.subdomain.invalid) {
          <mat-hint class="text-danger">
            @if (siteForm.controls.subdomain.errors?.['required']) {
              {{ 'subdomain_site_cannot_be_empty' | translate }}.
            }
            @if (siteForm.controls.subdomain.errors?.['minlength']) {
              {{ 'subdomain_min_length' | translate }}
            }
          </mat-hint>
        }
        <app-checkbox
          [ngModel]="$safeNavigationMigration(siteForm.get('is_product')?.value)"
          (ngModelChange)="onCheckboxChange($event)"
          [ngModelOptions]="{ standalone: true }"
          >{{ 'sell_product' | translate }}</app-checkbox
        >
        @if (this.siteForm.controls.is_product.value) {
          <app-text-field
            label="{{ 'name_of_product' | translate }}"
            [formControl]="siteForm.controls.product"
            [error]="siteForm.controls.product.invalid && siteForm.controls.product.touched"
          ></app-text-field>
        }
        @if (siteForm.controls.product.touched && siteForm.controls.product.invalid) {
          <mat-hint class="text-danger">
            @if (siteForm.controls.product.errors?.['required']) {
              {{ 'field_cannot_be_empty' | translate }}.
            }
          </mat-hint>
        }
        @if (this.siteForm.controls.is_product.value) {
          <app-text-field
            label="{{ 'price' | translate }}"
            [formControl]="siteForm.controls.price"
            [error]="siteForm.controls.price.invalid && siteForm.controls.price.touched"
          ></app-text-field>
        }
        @if (siteForm.controls.price.touched && siteForm.controls.price.invalid) {
          <mat-hint class="text-danger">
            @if (siteForm.controls.price.errors?.['required']) {
              {{ 'field_cannot_be_empty' | translate }}.
            }
          </mat-hint>
        }
        <mat-divider></mat-divider>
        <div class="bg-white d-flex position-sticky bottom-0 gap-2 p-4">
          <app-button [customClass]="'bg-danger'" class="mt-2" (onChangeClick)="onNoClick()"
            >{{ 'cancel' | translate }}
          </app-button>
          <div class="flex-fill"></div>
          @if (!isUpdate) {
            <app-button class="mt-2" (onChangeClick)="onSubmit()">{{ 'save' | translate }}</app-button>
          }
          @if (isUpdate) {
            <app-button class="mt-2" (onChangeClick)="onUpdate()">{{ 'change' | translate }}</app-button>
          }
        </div>
      </div>
    }
  }
</div>
